<template>
    <uiPage :blok="blok" :airport="blok.AirportEntity" />
    <StoryblokComponent
        v-if="globalStore && globalStore.signInModal"
        :global="globalStore.global.content"
        :blok="globalStore.signInModal"
    />
    <StoryblokComponent
        v-if="globalStore && globalStore.resetPasswordModal"
        :global="globalStore.global.content"
        :blok="globalStore.resetPasswordModal"
    />
    <StoryblokComponent
        v-if="globalStore && globalStore.signUpModal"
        :global="globalStore.global.content"
        :blok="globalStore.signUpModal"
    />
    <Component
        :is="globalStore.subscribeModal.component"
        v-if="globalStore && globalStore.subscribeModal"
        :global="globalStore.global.content"
        :blok="globalStore.subscribeModal"
    />
</template>

<script setup lang="ts">
import { useGlobalStore } from '@nuxt-monorepo/base/app/store/global';

const { blok } = defineProps({ blok: Object });

// Constant variable for access to quote store
const globalStore = useGlobalStore();
</script>
<style lang="postcss" scoped>
:deep(.rich-text) p {
    @apply leading-6;
}
</style>
